interface PositionBadgeProps {
  position: number;
  prevPosition: number | null;
}

export default function PositionBadge({
  position,
  prevPosition,
}: PositionBadgeProps) {
  if (prevPosition === null) {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs font-semibold text-emerald-400">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
          <path d="M5 0L9 6H1L5 0Z" />
        </svg>
        NEW
      </span>
    );
  }

  const diff = prevPosition - position;

  if (diff > 0) {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs font-semibold text-emerald-400">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
          <path d="M5 2L8 6H2L5 2Z" />
        </svg>
        {diff}
      </span>
    );
  }

  if (diff < 0) {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs font-semibold text-red-400">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
          <path d="M5 8L2 4H8L5 8Z" />
        </svg>
        {Math.abs(diff)}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center text-xs text-white/30">—</span>
  );
}
